import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Main from './views/Main.vue'
import NewsViews from './views/NewsViews.vue'
import NewsInfo from './views/NewsInfo.vue'
import Show from './views/Show.vue'
import Inquery from './views/Inquery.vue'
import InqueryM from './views/InqueryM.vue'
import Message from './views/Message.vue'
import CreateCbry from './views/createCert/CreateCbry.vue'
import CreateQyzs from './views/createCert/CreateQyzs.vue'
import CreateCbdw from './views/createCert/CreateCbdw.vue'
Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const router = new Router({
  mode: 'history',
  linkActiveClass: "",
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'index',
    component: Index,
    //redirect: "/",
    children: [
      {
        path: '/message',
        name: 'Message',
        component: Message,
      },
      {
        path: '/news/views/:plateId',
        name: 'newsviews',
        component: NewsViews,
      },
      {
        path: '/news/info/:plateId/:articleId',
        name: 'newsinfo',
        component: NewsInfo,
      },
      {
        path: '/',
        name: 'home',
        component: Main,
      }
    ]
  }, {
    path: '/inquery',
    name: 'inquery',
    component: Inquery,
  }, {
    path: '/inqueryM',
    name: 'inqueryM',
    component: InqueryM,
  }, {
    path: '/show',
    name: 'Show',
    component: Show,
  }, {
    path: '/CreateCbry',
    name: 'CreateCbry',
    component: CreateCbry,
  }, {
    path: '/CreateQyzs',
    name: 'CreateQyzs',
    component: CreateQyzs,
  }, {
    path: '/CreateCbdw',
    name: 'CreateCbdw',
    component: CreateCbdw,
  }
  ]
})

// // 添加路由守卫
// router.beforeEach((to, from, next) => {
//   const isLogin = localStorage.eleToken ? true : false;
//   next();
// })
// let router = createRouter({
//   history: createWebHistory(),
//   routes,
//   linkExactActiveClass: "selected"
// })

export default router;